import { render, staticRenderFns } from "./GeneralUserMessage.vue?vue&type=template&id=3fa908f5&scoped=true&"
import script from "./GeneralUserMessage.vue?vue&type=script&lang=js&"
export * from "./GeneralUserMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa908f5",
  null
  
)

export default component.exports